import { Component, forwardRef, ChangeDetectorRef, Injector, Input, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BH_MODE_SELECTION_SITE, BHQrCodeSiteScannerModel } from '../bh-qrcode-site-scanner.model';
import { PlatformService } from 'src/app/core-api/platform/platform.service';
import { AbstractWorkflowFormComponent } from '../../../@core/abstract-workflow-form-component';
import { WorkflowComponentsService } from '../../../workflow-components.service';
import { BHQrCodeSiteScannerService } from '../bh-qrcode-site-scanner.service';
import * as moment from 'moment';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatDialog } from '@angular/material/dialog';
import { MdBhQrCodeSiteScannerMotifDialog } from './@modals/md-bh-qrcode-site-scanner-motif-dialog/md-bh-qrcode-site-scanner-motif-dialog.component';

@Component({
  selector: 'abw-bh-qrcode-site-scanner-form',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BHQrCodeSiteScannerFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BHQrCodeSiteScannerFormComponent),
      multi: true
    }
  ],
  templateUrl: './bh-qrcode-site-scanner-form.component.html',
  styleUrls: ['./bh-qrcode-site-scanner-form.component.scss']
})
export class BHQrCodeSiteScannerFormComponent extends AbstractWorkflowFormComponent<BHQrCodeSiteScannerModel, any> implements OnChanges {
  codeScanned: string;
  siteInfos: any;
  dateControle = moment().format('YYYY-MM-DD');
  presences: any = {};
  errString: string;
  motifs: any = {};
  BH_MODE_SELECTION_SITE = BH_MODE_SELECTION_SITE;
  @Input() modeSelectionSite = BH_MODE_SELECTION_SITE.SCANNER;
  datasourceSitesInfos: any;
  datasourceValueColumn = '';
  datasourceDisplayColumn = '';
  datasourceSitesDatas: any[] = [];
  datasourceSitesFilteredDatas: any[] = [];

  constructor(
    private platformService: PlatformService,
    private dialog: MatDialog,
    _workflowComponentsService: WorkflowComponentsService,
    _cdf: ChangeDetectorRef,
    _injector: Injector,
    private bhQrCodeScannerService: BHQrCodeSiteScannerService
  ) {
    super(_workflowComponentsService, _cdf, _injector);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes.model) {
      if (!!this.model.additional.UIC_PARAMS['DATASOURCE_SITE']) {
        this.datasourceSitesInfos = this.model.additional.UIC_PARAMS['DATASOURCE_SITE'];
        this.datasourceValueColumn = this.datasourceSitesInfos.DATASOURCE_VALUE_FIELD;
        this.datasourceDisplayColumn = this.datasourceSitesInfos.DATASOURCE_DISPLAY_FIELD;
        this.datasourceSitesDatas = this.datasourceSitesInfos.DATASOURCE_DATAS;
        this.datasourceSitesFilteredDatas = this.datasourceSitesInfos.DATASOURCE_DATAS;
      }
    }
  }

  async scanCode() {
    try {
      const urlScanned = await this.platformService.scanQRCode();
      const regex = /[?&]token=([^&]+)/;
      const match = urlScanned.match(regex);
      if (match.length < 2) {
        throw "le QR code scanné est invalide";
      }

      this.codeScanned = match[1];
      await this.fetchSiteInfos(this.codeScanned);
    } catch (e) {
      console.error(e);
      this.errString = e;
      this._cdf.detectChanges();
    }
  }

  async fetchSiteInfos(codeSite: string) {
    this.siteInfos = await this.bhQrCodeScannerService.doGetSiteInfosAction({

      NUM_DS_AGENTS: this.model.additional.NUM_DATASOURCE_AGENT.NUM_DATASOURCE,
      ID_DS_AGENT_COLUMN: this.model.additional.ID_DATASOURCE_AGENT_COLUMN,
      FULLNAME_DS_AGENT_COLUMN: this.model.additional.FULLNAME_DATASOURCE_AGENT_COLUMN,

      NUM_DS_SITES: this.model.additional.NUM_DATASOURCE_SITE.NUM_DATASOURCE,
      ID_DS_SITE_COLUMN: this.model.additional.ID_DATASOURCE_SITE_COLUMN,
      QRCODE_DS_SITE_COLUMN: this.model.additional.QRCODE_DATASOURCE_SITE_COLUMN,

      NUM_DS_PLANNER: this.model.additional.NUM_DATASOURCE_PLANNER.NUM_DATASOURCE,
      QR_CODE: this.codeScanned,
    }).toPromise();
    this.siteInfos.AGENTS.forEach(a => {
      this.presences[a.ID] = a.ABSENT === undefined || a.ABSENT == '0';
    });
    this.onPresenceChecked();
    this._cdf.detectChanges();
  }

  onPresenceChecked() {
    this.value = {
      CODE_SITE: this.siteInfos.SITE.CODE_CLIENT,
      NOM_SITE: this.siteInfos.SITE.NOM_CLIENT,
      ZONE: this.siteInfos.SITE.ZONE,
      AGENTS: this.siteInfos.AGENTS,
      DATE_CONTROLE: this.dateControle,
      PRESENCES: this.presences,
      MOTIFS: this.motifs,
      TOTAL_PRESENCES: this.countPresences()
    };
    this.onValueChanged(this.value);
  }

  countPresences() {
    return Object.keys(this.presences).filter(k => this.presences[k] == true).length;
  }

  /*validate({ value }: FormControl): any {
    if (!value || !value.AGENTS || !value.PRESENCES || !value.MOTIFS) {
      return { invalid: true };
    }
    
    const validation = (value.AGENTS as any[]).reduce((acc, agent) => {
      return acc && (value.PRESENCES[agent.ID] == true || !!value.MOTIFS[agent.ID]);
    }, true);
    return { invalid: !validation };
  }*/

  openMotifDialog(agent: any) {
    this.dialog.open(MdBhQrCodeSiteScannerMotifDialog, {
      data: {
        dateControle: this.dateControle,
        site: this.siteInfos.SITE,
        agent: agent,
        presence: this.presences[agent.ID],
        allAgents: this.siteInfos.ALL_AGENTS,
        motif: this.motifs[agent.ID] || null
      },
      width: '100vw',
      panelClass: 'datasource-designer-modal'
    }).afterClosed().subscribe(result => {
      if (!result) { return; }
      this.motifs[agent.ID] = result;
      this.onPresenceChecked();
    });
  }

	async onSiteSelected(codeSite: string) {
    try {
      this.siteInfos = null;
      this.codeScanned = codeSite;
      await this.fetchSiteInfos(this.codeScanned);
    } catch (e) {
      console.error(e);
      this.errString = e;
      this._cdf.detectChanges();
    }
	}

  handleFilter(value) {
    this.datasourceSitesFilteredDatas = this.datasourceSitesDatas.filter(
      d => !!d && !!d[this.datasourceDisplayColumn] && d[this.datasourceDisplayColumn].toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }
}